import { config } from "../config";

export default function fetchApi(endpoint?: string, options: RequestInit = {}) {
  const apiHost = config.REACT_APP_PROXY_BASE_URL;

  return {
    get: async <T>(params?: any): Promise<T> => {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(options.headers as any),
      };

      const data = await fetch(`${apiHost}/${endpoint}${params || ""}`, {
        method: "GET",
        headers,
      });

      return data.json();
    },
    logo: async (params?: any): Promise<Blob> => {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(options.headers as any),
      };

      const data = await fetch(`${apiHost}/${endpoint}${params || ""}`, {
        method: "GET",
        headers,
      });

      return data.blob();
    },
    post: async (params?: any) => {
      const headers = {
        Accept: "*/*",
        "Content-Type": "application/json",
        ...(options.headers as any),
      };

      const data = await fetch(`${apiHost}/${endpoint}`, {
        method: "POST",
        headers,
        body: JSON.stringify(params),
      });

      return data.json();
    },
  };
}

export function authApi() {
  const apiHost =
    config.REACT_APP_AUTH_URL + "/token?grant_type=client_credentials";

  const headers = {
    Authorization:
      "Basic " + btoa(`${config.REACT_APP_USERNAME}:${config.REACT_APP_KEY}`),
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  return {
    get: async <T>(): Promise<T> => {
      const data = await fetch(`${apiHost}`, {
        method: "GET",
        headers,
      });

      return data.json();
    },
  };
}
